import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout, Loading } from "@/components/Layout";
import Login from "@/pages/Login";
import Setup from "@/pages/Setup";
import Dashboard from "@/pages/Dashboard";
import PlatformAdmin from "@/pages/PlatformAdmin";
import Syndication from "@/pages/Syndication";
import Channels from "@/pages/Channels";
import ChannelDetail from "@/pages/ChannelDetail";
import Programming from "@/pages/Programming";
import AssetLibrary from "@/pages/AssetLibrary";
import Scheduler from "@/pages/Scheduler";
import Outputs from "@/pages/Outputs";
import Monitoring from "@/pages/Monitoring";
import Settings from "@/pages/Settings";
import SystemInfo from "@/pages/SystemInfo";
import AuditLog from "@/pages/AuditLog";

function Protected({ children, platform }) {
  const { user, needsSetup } = useAuth();
  if (needsSetup) return <Navigate to="/setup" replace />;
  if (user === null) return <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]"><Loading /></div>;
  if (user === false) return <Navigate to="/login" replace />;
  if (platform && user?.is_platform_admin !== true) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user, needsSetup } = useAuth();
  return (
    <Routes>
      <Route path="/setup" element={needsSetup ? <Setup /> : <Navigate to="/" replace />} />
      <Route path="/login" element={needsSetup ? <Navigate to="/setup" replace /> : (user ? <Navigate to="/" replace /> : <Login />)} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/platform" element={<Protected platform><PlatformAdmin /></Protected>} />
      <Route path="/syndication" element={<Protected platform><Syndication /></Protected>} />
      <Route path="/channels" element={<Protected><Channels /></Protected>} />
      <Route path="/channels/:id" element={<Protected><ChannelDetail /></Protected>} />
      <Route path="/programming" element={<Protected><Programming /></Protected>} />
      <Route path="/assets" element={<Protected><AssetLibrary /></Protected>} />
      <Route path="/media" element={<Protected><AssetLibrary /></Protected>} />
      <Route path="/scheduler" element={<Protected><Scheduler /></Protected>} />
      <Route path="/outputs" element={<Protected><Outputs /></Protected>} />
      <Route path="/monitoring" element={<Protected><Monitoring /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="/audit" element={<Protected><AuditLog /></Protected>} />
      <Route path="/system" element={<Protected><SystemInfo /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster theme="dark" position="bottom-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
